import {
    CardTemplate,
    InputField,
    Select,
    Toggle,
} from "@hatch-digital-nl/bravilor-storybook";
import { JSX } from "react";
import { useCheckoutFormContext } from "../CheckoutFormContext";
import { useCheckoutLabels } from "../hooks/useCheckoutLabels";
import { useCountries } from "../hooks/useCountries";

interface DeliveryAddressCardProps {
    isLoading?: boolean;
}

export const DeliveryAddressCard = ({
    isLoading = false,
}: DeliveryAddressCardProps): JSX.Element => {
    const labels = useCheckoutLabels();
    const { form, errors, isPrimary, updateField, setIsPrimary } =
        useCheckoutFormContext();
    const { options: countryOptions, isLoading: countriesLoading } =
        useCountries();

    const fieldLoading = isLoading;
    const countryLoading = isLoading || countriesLoading;

    return (
        <CardTemplate title={labels.deliveryAddressTitle} isLoading={isLoading}>
            <InputField
                id="checkout-address"
                label={labels.street}
                value={form.address}
                onChange={(value) => updateField("address", value)}
                placeholder={labels.streetPlaceholder}
                error={errors.address}
                required
                isLoading={fieldLoading}
            />
            <div className="p-checkout-page__field-row">
                <InputField
                    id="checkout-postal-code"
                    label={labels.postalCode}
                    value={form.postal_code}
                    onChange={(value) => updateField("postal_code", value)}
                    placeholder={labels.postalCodePlaceholder}
                    error={errors.postal_code}
                    required
                    isLoading={fieldLoading}
                />
                <InputField
                    id="checkout-city"
                    label={labels.city}
                    value={form.city}
                    onChange={(value) => updateField("city", value)}
                    placeholder={labels.cityPlaceholder}
                    error={errors.city}
                    required
                    isLoading={fieldLoading}
                />
            </div>
            <div className="p-checkout-page__field-row">
                <Select
                    variant="form"
                    id="checkout-country"
                    label={labels.country}
                    value={form.country_id}
                    onChange={(value) => updateField("country_id", value)}
                    options={countryOptions}
                    isLoading={countryLoading}
                    placeholder={labels.countryPlaceholder}
                    error={errors.country_id}
                    required
                />
                <InputField
                    id="checkout-notes"
                    label={labels.additionalNotes}
                    value={form.additional_notes}
                    onChange={(value) => updateField("additional_notes", value)}
                    placeholder={labels.additionalNotesPlaceholder}
                    isLoading={fieldLoading}
                />
            </div>
            <div className="p-checkout-page__primary-address-toggle">
                <Toggle
                    checked={isPrimary}
                    onChange={setIsPrimary}
                    label={labels.savePrimaryAddress}
                    description={labels.savePrimaryAddressDescription}
                    disabled={fieldLoading}
                />
            </div>
        </CardTemplate>
    );
};
